module.exports = __webpack_public_path__ + "img/Apple.5e84cda2.png";